import React from 'react'

import { Form } from '@/app/component/form'
import { ActionsContainer, FlexFormContainer } from '@/app/component/form/common'
import SubmitButton from '@/app/component/form/submit-button'
import { useCreateCustomFields } from '@/app/module/custom-fields/hooks/use-create-custom-fields'

import { CustomFieldsFormValues, createCFDefaultValues, createCFFields, createCFSchema } from './specs'

type Props = {
  onExit: () => void
}

const CreateCustomFieldsForm: React.FC<Props> = ({ onExit }) => {
  const [createCustomFields, { isLoading }] = useCreateCustomFields()

  const handleSubmit = React.useCallback(
    async (data: CustomFieldsFormValues) => {
      const result = await createCustomFields(data.names)
      if (result) {
        onExit()
      }
    },
    [createCustomFields, onExit],
  )

  return (
    <FlexFormContainer>
      <Form
        defaultValues={createCFDefaultValues}
        fields={createCFFields}
        schema={createCFSchema}
        onSubmit={handleSubmit}
        renderActions={({ isDirty }) => (
          <ActionsContainer>
            <SubmitButton isDirty={isDirty} isSubmitting={isLoading}>
              Save
            </SubmitButton>
          </ActionsContainer>
        )}
      />
    </FlexFormContainer>
  )
}

export default CreateCustomFieldsForm
